export default __webpack_public_path__ + "static/media/gallery_02.af0a6d4f.jpg";